// Update this URL when the waitlist Google Form is ready
export const WAITLIST_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfgfscjIUqfGG4Q49oBBWDdu1o7w7CM-rScwSzwbQGzg2hNkw/viewform?usp=dialog";

export const INSTAGRAM_HANDLE = "@white.rabbit.motorsports";
export const INSTAGRAM_URL =
  "https://www.instagram.com/white.rabbit.motorsports";

// Public routes shown in the landing nav and footer. Only public routes
// belong here: a visitor must never land on a login wall. /plans stays
// out until billing ships (see the route comment in routesConfig.ts).
export const MARKETING_LINKS = [
  {
    to: "/trackcast",
    labelKey: "common:navigation.trackcast",
    badgeKey: "common:navigation.badgeNew",
  },
  { to: "/sessions/all", labelKey: "common:navigation.sessions" },
  { to: "/events", labelKey: "common:navigation.events" },
] as const;

// Looping onboard clip for the hero. Rebuild with tools/video/fuse-loop.sh;
// see docs/src/content/docs/development/hero-video.md.
export const HERO_VIDEO_SRC = "/videos/home-hero-loop.mp4";
export const HERO_VIDEO_POSTER = "/videos/home-hero-loop-poster.jpg";
